import React, { useCallback } from "react";
import { connect } from "react-redux";

import { FieldTeamVisibility } from "@mapmycustomers/shared/enum/FieldVisibility";
import Role from "@mapmycustomers/shared/types/Role";
import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";

import { getRolesExcludingOwners } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";

import RoleItem from "./RoleItem";
import styles from "./RolesVisibilityList.module.scss";

interface Props {
  calculatedField?: boolean;
  disabledFieldVisibilities?: FieldTeamVisibility[];
  onChange?: (value: Record<Role["id"], FieldTeamVisibility>) => void;
  phiEnabled?: boolean;
  roles: Role[];
  schemaField?: SchemaField;
  value?: Record<Role["id"], FieldTeamVisibility>;
}

const RolesVisibilityList: React.FC<Props> = ({
  calculatedField,
  disabledFieldVisibilities,
  onChange,
  phiEnabled,
  roles,
  schemaField,
  value,
}) => {
  const handleChange = useCallback(
    (role: Role, visibility: FieldTeamVisibility) =>
      onChange?.({ ...value, [role.id]: visibility }),
    [onChange, value]
  );

  return (
    <div className={styles.container}>
      {roles.map((role) => (
        <RoleItem
          calculatedField={calculatedField}
          disabledFieldVisibilities={disabledFieldVisibilities}
          field={schemaField}
          key={role.id}
          onChange={handleChange}
          phiEnabled={phiEnabled}
          role={role}
          value={value?.[role.id]}
        />
      ))}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  roles: getRolesExcludingOwners(state),
});

export default connect(mapStateToProps)(RolesVisibilityList);
